import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { AppContext } from '../../context/AppContext';
import { AddEditCategory } from '../../pages/Categories/AddEditCategory';
import { AddEditSubCategory } from '../../pages/Categories/SubCategories/AddEditSubCategory';
import { AddIngredient } from '../../pages/Products/AddIngredient';
import { EditOrder } from '../../pages/Orders/EditOrder';
import { ProductionCancelOrder } from '../../pages/Production/ProductionCancelOrder';
import { InvoiceSummary } from '../../pages/Shipping/InvoiceSummary';
import { SupplierNotesHistory } from '../../pages/Orders/SupplierNotesHistory';
import { StoreNotesHistory } from '../../pages/Orders/StoreNotesHistory';
import { AddTax } from '../../pages/Stores/AddTax';
import { AddShippingMethod } from '../../pages/Stores/AddShippingMethod';
import { ViewImage } from '../../pages/Stores/ViewImage';
import { ShippedOrder } from '../../pages/Orders/ShippedOrder';

export interface BakeasyDialogProps {
  fullWidth?: boolean;
  dialog?: BakeasyDialogProp;
}

export interface BakeasyDialogProp {
  isDelete?: boolean | false;
  open?: boolean;
  title?: any;
  message?: string;
  dialogContent?: any;
  fullWidth?: boolean;
  onYesClick?: (event: React.MouseEvent<HTMLButtonElement>, param?: string) => void;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) }
}));

export default function BakeasyDialog(props: BakeasyDialogProps) {
  let myContext = React.useContext(AppContext);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('lg');

  function handleOnClose() {
    myContext.setDialog({ open: false });
  }

  React.useEffect(() => {
    const pageName = props?.dialog?.dialogContent?.pageName;
    if (pageName === 'ShippedOrder' || pageName === 'invoiceSummary') {
      setMaxWidth('lg');
    } else {
      setMaxWidth('sm');
    }
  }, [props?.dialog?.dialogContent?.pageName]);

  function renderUI(pageName: string) {
    switch (pageName) {
      case 'AddEditCategory':
        return <>{renderAddEditCategory()}</>;
      case 'AddEditSubCategory':
        return <>{renderAddEditSubCategory()}</>;
      case 'AddIngredient':
        return <>{renderAddIngredient()}</>;
      case 'EditOrder':
        return <>{renderEditOrder()}</>;
      case 'ProductionCancelOrder':
        return <>{renderProductionCancelOrder()}</>;
      case 'invoiceSummary':
        return <>{renderInvoiceEdit()}</>;
      case 'supplierNotesHistory':
        return <>{renderSupplierDialog()}</>;
      case 'storeNotesHistory':
        return <>{renderStoreDialog()}</>;
      case 'AddTax':
        return <>{renderAddTax()}</>;
      case 'AddShippingMethod':
        return <>{renderAddShippingMethod()}</>;
      case 'ViewImage':
        return <>{renderViewImage()}</>;
      case 'ShippedOrder':
        return <>{renderShippedOrder()}</>;
    }
  }

  function renderSupplierDialog() {
    return (
      <SupplierNotesHistory
        from={props?.dialog?.dialogContent?.params?.from}
        fetchMethod={props?.dialog?.dialogContent?.params?.fetchMethod}
      />
    );
  }

  function renderStoreDialog() {
    return <StoreNotesHistory from={props?.dialog?.dialogContent?.params?.from} />;
  }

  function renderInvoiceEdit() {
    return <InvoiceSummary {...props?.dialog?.dialogContent} />;
  }

  function renderAddIngredient() {
    return <AddIngredient {...props?.dialog?.dialogContent}></AddIngredient>;
  }

  function renderAddEditCategory() {
    return <AddEditCategory {...props?.dialog?.dialogContent}></AddEditCategory>;
  }

  function renderEditOrder() {
    return <EditOrder {...props?.dialog?.dialogContent}></EditOrder>;
  }

  function renderAddEditSubCategory() {
    return <AddEditSubCategory {...props?.dialog?.dialogContent}></AddEditSubCategory>;
  }

  function renderProductionCancelOrder() {
    return <ProductionCancelOrder {...props?.dialog?.dialogContent}></ProductionCancelOrder>;
  }

  function renderAddTax() {
    return <AddTax {...props?.dialog?.dialogContent}></AddTax>;
  }
  function renderAddShippingMethod() {
    return <AddShippingMethod {...props?.dialog?.dialogContent}></AddShippingMethod>;
  }

  function renderViewImage() {
    return <ViewImage {...props?.dialog?.dialogContent} />;
  }

  function renderShippedOrder() {
    return <ShippedOrder {...props?.dialog?.dialogContent}></ShippedOrder>;
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        fullWidth={true}
        maxWidth={maxWidth}
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={props?.dialog?.open ? props?.dialog?.open : false}
      >
        {renderUI(props?.dialog?.dialogContent?.pageName)}
      </BootstrapDialog>
    </React.Fragment>
  );
}
